import React from 'react'

const Footer = () => {
  const [showCookieSettings, setShowCookieSettings] = React.useState(false)

  const handleCookieSettings = () => {
    // Remove existing consent to show banner again
    localStorage.removeItem('cookieConsent')
    // Reload page to show cookie banner
    window.location.reload()
  }

  return (
    <footer className="bg-brand-dark text-brand-bg">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 text-center md:text-left">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-serif font-bold mb-4">Floricoltura Lampugnani</h3>
            <p className="text-brand-bg/70 mb-4">Scenografie verdi per eventi indimenticabili.</p>
          </div>
          
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold mb-3 text-brand-accent">Sedi</h4>
            <div className="space-y-2 text-sm text-brand-bg/70">
              <div>
                <p>Via Briantea 25c</p>
                <p>22030 Orsenigo (CO)</p>
              </div>
              <div>
                <p>Via Michele Barozzi 6</p>
                <p>20122 Milano (MI)</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-1 flex justify-center md:justify-end">
            <div className="flex space-x-6">
              <a href="#" aria-label="Facebook" className="text-brand-bg/70 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v2.385z"/>
                </svg>
              </a>
              <a href="#" aria-label="Instagram" className="text-brand-bg/70 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.85s-.011 3.584-.069 4.85c-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.584-.012-4.85-.07c-3.252-.148-4.771-1.691-4.919-4.919-.058-1.265-.069-1.645-.069-4.85s.011-3.584.069-4.85c.149-3.225 1.664-4.771 4.919-4.919 1.266-.057 1.644-.069 4.85-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.059-1.281.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.2-4.358-2.618-6.78-6.98-6.98-1.281-.058-1.689-.072-4.948-.072zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44 1.441-.645 1.441-1.44-.645-1.44-1.441-1.44z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-brand-light-green/20">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-brand-bg/50">
            <p>&copy; {new Date().getFullYear()} Floricoltura Lampugnani S.r.l. | P.IVA IT 02404550135</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a href="#" className="hover:text-brand-bg/70 transition-colors">Privacy Policy</a>
              <span>|</span>
              <button 
                onClick={handleCookieSettings}
                className="hover:text-brand-bg/70 transition-colors cursor-pointer"
              >
                Impostazioni Cookie
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer